import React from 'react';

import LoadingDialog from 'components/Dialogs/LoadingDialog';
import ReviewDialog from 'components/Dialogs/ScheduledTransactionAddDialog/ReviewDialog';
import ScheduledTransactionEditDialog from 'components/Dialogs/ScheduledTransactionEditDialog';
import SelectScheduledTransactionDialog from 'components/Dialogs/SelectScheduledTransactionDialog';

import type { TransactionEditViewModel } from '../TransactionEditViewModel';

type Props = {
  viewModel: TransactionEditViewModel;
};

export default function WorkflowDialogComponents({ viewModel }: Props): React.JSX.Element {
  const {
    actions: {
      closeAll,
      closeRecurring,
      createRecurring,
      exitRecurringCreate,
      exitRecurringSelect,
      linkRecurring,
      onCloseReview,
      onEditSeriesFromReview,
      saveRecurring,
      updateRecurring,
    },
    derived: {
      completionText,
      currentTxn,
      editSeriesAssignSplits,
      editSeriesInitialTab,
      editSeries,
      loadingLine,
      model,
      showConfirmation,
      showEditRecurring,
      showRecurringSelect,
      waiting,
      workflowView,
    },
  } = viewModel;

  const activeWorkflowView =
    workflowView ??
    (waiting || completionText
      ? 'progress'
      : showConfirmation
        ? 'review'
        : editSeries
          ? 'edit-series'
          : showEditRecurring
            ? 'recurring-create'
            : showRecurringSelect
              ? 'recurring-select'
              : 'transaction');

  return (
    <React.Fragment>
      {activeWorkflowView === 'recurring-create' && model && (
        <ScheduledTransactionEditDialog
          fakeCreate
          open={!waiting}
          scheduledTransaction={model}
          onSubmit={saveRecurring}
          onClose={closeAll}
          onBack={exitRecurringCreate}
          title='Create series'
        />
      )}

      {activeWorkflowView === 'review' && (
        <ReviewDialog
          open
          model={model}
          onClose={onCloseReview}
          edit={onEditSeriesFromReview}
          sharedcomponentid='SCHEDULED_TRANSACTION_ADD_DIALOG'
        />
      )}

      {activeWorkflowView === 'edit-series' && model && (
        <ScheduledTransactionEditDialog
          open
          key={model.clientId || model.id}
          scheduledTransaction={model}
          onClose={closeRecurring}
          onSubmit={updateRecurring}
          initialTab={editSeriesInitialTab}
          initialShowAssignSplits={editSeriesAssignSplits}
        />
      )}

      {activeWorkflowView === 'recurring-select' && (
        <SelectScheduledTransactionDialog
          open={!waiting}
          onClose={closeAll}
          onSelected={linkRecurring}
          onCreate={createRecurring}
          showBackButton
          onBack={exitRecurringSelect}
          txn={currentTxn}
        />
      )}

      {activeWorkflowView === 'progress' && (
        <LoadingDialog
          open
          onClose={closeAll}
          loading={waiting}
          loadingString={loadingLine}
          successString={completionText}
        />
      )}
    </React.Fragment>
  );
}
